import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_FLEET_USER_GROUP_PRICING = createActionTypes('FETCH_FLEET_USER_GROUP_PRICING');
export const CREATE_FLEET_USER_GROUP_PRICING = createActionTypes('CREATE_FLEET_USER_GROUP_PRICING');
export const DELETE_FLEET_USER_GROUP_PRICING = createActionTypes('DELETE_FLEET_USER_GROUP_PRICING');
export const UPDATE_FLEET_USER_GROUP_PRICING = createActionTypes('UPDATE_FLEET_USER_GROUP_PRICING');
export const GET_FLEET_USER_GROUP_PRICING = createActionTypes('GET_FLEET_USER_GROUP_PRICING');